import {
  Proposal,
  ProposalHistoryVersion,
  ProposalRow,
  ProposalStatus
} from "./types";

// The versions shown and opened as earlier ones, from a newest-first history:
// the latest is the proposal itself, and an earlier draft was never sent.
export const earlierSentVersions = (versions: ProposalHistoryVersion[]) =>
  versions
    .slice(1)
    .filter((version) => version.status !== ProposalStatus.DRAFT);

// A version shown as a proposal of its own, for its table row and its page:
// the proposal's name, the version's status, signing and dates. Nothing on it
// can be changed, so it carries no actions.
export const versionAsProposal = (
  proposal: Proposal,
  version: ProposalHistoryVersion
): ProposalRow => ({
  id: proposal.id,
  name: proposal.name,
  status: version.status,
  signedCount: version.signedCount,
  signerCount: version.signerCount,
  recipientStates: version.recipientStates,
  createdAt: version.createdAt,
  updatedAt: version.updatedAt,
  createdBy: version.createdBy,
  actions: [],
  earlierVersionId: version.id
});
